export const stateAbbreviations = {
  ALABAMA: "AL",
  ALASKA: "AK",
  ARIZONA: "AZ",
  ARKANSAS: "AR",
  CALIFORNIA: "CA",
  COLORADO: "CO",
  CONNECTICUT: "CT",
  DELAWARE: "DE",
  FLORIDA: "FL",
  GEORGIA: "GA",
  HAWAII: "HI",
  IDAHO: "ID",
  ILLINOIS: "IL",
  INDIANA: "IN",
  IOWA: "IA",
  KANSAS: "KS",
  KENTUCKY: "KY",
  LOUISIANA: "LA",
  MAINE: "ME",
  MARYLAND: "MD",
  MASSACHUSETTS: "MA",
  MICHIGAN: "MI",
  MINNESOTA: "MN",
  MISSISSIPPI: "MS",
  MISSOURI: "MO",
  MONTANA: "MT",
  NEBRASKA: "NE",
  NEVADA: "NV",
  "NEW HAMPSHIRE": "NH",
  "NEW JERSEY": "NJ",
  "NEW MEXICO": "NM",
  "NEW YORK": "NY",
  "NORTH CAROLINA": "NC",
  "NORTH DAKOTA": "ND",
  OHIO: "OH",
  OKLAHOMA: "OK",
  OREGON: "OR",
  PENNSYLVANIA: "PA",
  "RHODE ISLAND": "RI",
  "SOUTH CAROLINA": "SC",
  "SOUTH DAKOTA": "SD",
  TENNESSEE: "TN",
  TEXAS: "TX",
  UTAH: "UT",
  VERMONT: "VT",
  VIRGINIA: "VA",
  WASHINGTON: "WA",
  "WEST VIRGINIA": "WV",
  WISCONSIN: "WI",
  WYOMING: "WY",
} as const

export const stateNameToAbbrev = (name: string): string => {
  const upperName = name.toUpperCase().trim()
  // If input is already a valid abbreviation, return it
  if (Object.values(stateAbbreviations).includes(upperName as any)) {
    return upperName
  }
  // Try to convert from full name
  const abbrev = stateAbbreviations[upperName as keyof typeof stateAbbreviations]
  if (abbrev) {
    return abbrev
  }
  // If not found, try to match partial names
  const partialMatch = Object.entries(stateAbbreviations).find(([fullName]) =>
    upperName.split(" ").every((word) => fullName.includes(word)),
  )
  if (partialMatch) {
    return partialMatch[1]
  }
  // Special case for Alabama
  if (upperName.startsWith("ALA") || upperName === "AL") {
    return "AL"
  }
  // If still not found, return the original input
  return name.trim()
}

export const stateAbbrevToName = (abbrev: string): string => {
  const upperAbbrev = abbrev.toUpperCase().trim()
  return Object.entries(stateAbbreviations).find(([_, abb]) => abb === upperAbbrev)?.[0] || upperAbbrev
}
